import type { UploadFileRejection } from 'src/lib/pricelist-utils';

export function initialPricelistUploadFiles(
  initialFile: File | null,
  initialFiles: readonly File[],
): File[] {
  if (initialFiles.length > 0) return [...initialFiles];
  return initialFile ? [initialFile] : [];
}

export function pricelistFilesToUpload(
  caseMode: boolean,
  selectedFiles: readonly File[],
  selectedFile: File | null,
): File[] {
  if (caseMode) return [...selectedFiles];
  return selectedFile ? [selectedFile] : [];
}

export function caseUploadRejectionFeedback(
  rejections: readonly UploadFileRejection[],
): {
  sizeError: string | null;
  toasts: UploadFileRejection[];
} {
  let sizeError: string | null = null;
  const toasts: UploadFileRejection[] = [];
  for (const rejection of rejections) {
    if (rejection.kind === 'too-large') {
      sizeError = rejection.message;
    } else {
      toasts.push(rejection);
    }
  }
  return { sizeError, toasts };
}
